// Human labels for normalized routes (analyticsRouteNormalizer) and activities.
const PAGE_LABELS = {
  '/': 'Landing',
  '/schedules': 'Schedules',
  '/patients': 'Patient roster',
  '/patient/:id': 'Patient chart',
  '/visit/:id': 'Visit document',
  '/edit-document/:id': 'Document editor',
  '/reports/:id': 'Reports',
  '/search': 'Search',
  '/admin-page': 'Admin',
  '/admin-dashboard': 'Admin dashboard',
  '/super-admin': 'Super Admin',
  '/compliance': 'Compliance',
  '/audio-recorder': 'Recorder',
  '/recording': 'Recorder',
  '/recent-audios': 'Recent audios',
  '/settings': 'Settings',
  '/monitor': 'Monitor',
  '/no-shows': 'No-shows',
  '/file-upload': 'File upload',
  '/upload-files/:id': 'File upload',
  '/upload-json': 'JSON upload',
  '/pdf-viewer': 'PDF viewer',
  '/analyze': 'Analyze',
  '/messages/:id': 'Messages',
  '/forms/:id': 'Forms',
  '/help-desk': 'Help desk',
  '/terms-of-service': 'Terms',
  '/auth': 'Sign in',
  '/signout': 'Sign out',
  '/confirm-admin': 'Confirm admin',

  // Additional routes read from App.js:2734-2951 (the full <Routes> table).
  '/auth/callback': 'Auth callback',
  '/auth/complete-signup': 'Complete signup',
  '/auth/confirm': 'Email confirmation',
  '/auth/patient-verification': 'Patient verification',
  '/auth/reset-password': 'Reset password',
  '/403': 'Forbidden',
  '/patient/:id/edit-document': 'Document editor',
  '/visit/:id/edit-document': 'Document editor',
  '/edit-document': 'Document editor',
};

export const ACTIVITY_LABELS = {
  ai_chat: 'AI chat',
  clinic_ai_chat: 'Clinic AI chat',
  processing_document: 'Processing document',
  recording: 'Recording',
  transcribing: 'Transcribing',
  uploading: 'Uploading',
  fax_matching: 'Matching faxes',
};

export function pageLabel(route) {
  if (!route) return '—';
  if (PAGE_LABELS[route]) return PAGE_LABELS[route];
  if (route.startsWith('/clinic')) return 'Clinic';
  if (route.startsWith('/patient-portal') || route.startsWith('/portal')) return 'Patient portal';
  // /patients/:uuid (MedStudentClinicPage, source="roster") isn't covered by
  // analyticsRouteNormalizer's prefix list, so the raw uuid reaches here.
  if (route.startsWith('/patients/')) return 'Patient chart';
  // /book/:slug (public booking link) isn't normalized either.
  if (route.startsWith('/book/')) return 'Booking link';
  // /visit/:uuid/edit-document/:documentId? — normalizeRoute only templates the
  // first (visit) id, so a present documentId trails the route literally.
  if (route.startsWith('/visit/:id/edit-document')) return 'Document editor';
  // /schedules/* (nested Schedules sub-router) — only the exact "/schedules"
  // has a literal key above; any nested view path falls through to here.
  if (route.startsWith('/schedules/')) return 'Schedules';
  return route;
}

export function activityLabel(name) {
  return ACTIVITY_LABELS[name] || name;
}
